import { PluginDefinition } from 'yam-types'
import scaleOperator from './handlers/keda-scale'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'
import { ScaleObjectSpec } from './types.d'

export default {
  name,
  schema,
  settings,
  version,
  handlers: {
    'scale': scaleOperator
  }
} as PluginDefinition<ScaleObjectSpec>